import classnames from "classnames";
import React from "react";
import padStart from "lodash/padStart";
import PropTypes from "prop-types";
import styles from "./SliderTimeMarkerStyles.css";

export default function SliderTimeMarker(props) {
  const totalSeconds = Math.round(props.time / 1000);
  let seconds = String(totalSeconds % 60);
  seconds = padStart(seconds, 2, "0");

  let minutes = String(Math.floor(totalSeconds / 60));
  minutes = padStart(minutes, 2, "0");

  return (
    <div
      className={classnames(styles.root, {
        [styles.mouseOver]: props.mouseOver,
        [styles.nub]: props.nub,
      })}
      style={props.style}
    >
      {`${minutes}:${seconds}`}
    </div>
  );
}

SliderTimeMarker.propTypes = {
  mouseOver: PropTypes.bool,
  nub: PropTypes.bool,
  style: PropTypes.any,
  time: PropTypes.number.isRequired,
};
